import type { ReactNode } from 'react';

type ComparisonGroupProps = {
  heading?: string;
  testId: string;
  children: ReactNode;
};

export function ComparisonGroup({
  heading,
  testId,
  children,
}: Readonly<ComparisonGroupProps>) {
  return (
    <div className="flex flex-col gap-2" data-testid={testId}>
      {heading !== undefined && (
        <h3 className="text-sm font-semibold text-neut-prim">{heading}</h3>
      )}
      {children}
    </div>
  );
}
